import { cn } from '@/shared/lib'

// 우수 임대인 뱃지 너비(80px) + 여백(8px)
const SUPER_HOST_BADGE_OFFSET_WIDTH = 88

type Props = {
  roomName: string
  address: string
  isSuperHost: boolean
}

export const MobileRoomHeader = ({ roomName, address, isSuperHost }: Props) => {
  return (
    <section className="space-y-4">
      <h1
        className={cn(
          'typo-headline2 font-bold text-black',
          isSuperHost && `w-[calc(100%-${SUPER_HOST_BADGE_OFFSET_WIDTH}px)]`,
        )}
      >
        {roomName}
      </h1>
      <p className="typo-body2 font-normal text-gray-900">{address}</p>
    </section>
  )
}
